/**
 * API functions para validação de token usando a API de produção
 */

import { apiClient } from "@/_nucleo/api/client";
import type { AuthValidationResult } from "./_types";

/**
 * Valida o token atual fazendo uma requisição para a API de produção
 * Usa o endpoint de filiais como dummy para verificar se o token é válido
 */
export async function validateToken(): Promise<AuthValidationResult> {
  try {
    const response = await apiClient.production.get(
      "/reidoapsdu/consultar/filiais/"
    );
    return {
      success: true,
    };
  } catch (error: any) {
    if (error?.response?.status === 401) {
      return {
        success: false,
        error: "Token inválido ou expirado",
        needsRefresh: true,
      };
    }
    if (error?.response?.status >= 500) {
      return {
        success: false,
        error: "Erro do servidor - tentando renovar token",
        needsRefresh: true,
      };
    }
    return {
      success: false,
      error: error?.message || "Erro na validação do token",
    };
  }
}
